import { Pause, Play } from "lucide-react";
import { ComponentPropsWithoutRef, forwardRef, useContext } from "react";
import { Button } from "./ui/button";
import { audioPlayerContext } from "@/contexts/audioPlayerContext";
type AudioButtonProps = ComponentPropsWithoutRef<typeof Button> & {
    buttonText: string;
    audioTitle: string;
    audioUrl: string;
    playbackRate?: number;
    // className?: string;
    // onClick?: () => void;
    // onPlay?: () => void;
    // onPause?: () => void;
    // onEnded?: () => void;
};
const AudioButton = forwardRef<HTMLButtonElement, AudioButtonProps>(function AudioButton({ buttonText, audioTitle, audioUrl, playbackRate = 1, ...props }, ref) {
    const { setIsPlaying, isPlaying: isPlayerPlaying, audioUrl: currentAudioUrl, setAudioUrl, setOpen, setTitle, setPlaybackRate } = useContext(audioPlayerContext);
    const isPlaying = audioUrl === currentAudioUrl && isPlayerPlaying;

    const togglePlaying = () => {
        if (!isPlaying) {
            setAudioUrl(audioUrl);
            setOpen(true);
            setTitle(audioTitle);
            setPlaybackRate(playbackRate);
        }
        setIsPlaying(!isPlaying);
    };

    return (
        <Button
            {...props}
            ref={ref}
            onClick={togglePlaying}
        >
            {isPlaying ? <Pause /> : <Play />}
            {buttonText}
        </Button>
    );
});

export { AudioButton };
